import { z } from 'zod';
import { ZBaseIntegrationConfig } from './base.js';
export const SENDCLOUD_INTEGRATION_NAME = 'sendcloud';
export const ZSendcloudCredentials = z.object({
    publicKey: z.string().min(1, 'Public key is required'),
    secretKey: z.string().min(1, 'Secret key is required'),
});
export const ZSendcloudSettings = z.object({
    // The merchant simply declares which shipping methods should be treated as
    // Sendcloud pickup. The carrier/service (shipping_option_code) is configured
    // by the merchant directly in Sendcloud, not here.
    methods: z
        .array(z.object({
        shippingRateCode: z.string(),
        shippingMethodTitle: z.string(),
    }))
        .optional(),
});
export const ZSendcloudIntegrationConfig = ZBaseIntegrationConfig.extend(z.object({
    integrationName: z.literal(SENDCLOUD_INTEGRATION_NAME),
    category: z.literal('shipping'),
    credentials: ZSendcloudCredentials,
    settings: ZSendcloudSettings,
}).shape);
//# sourceMappingURL=sendcloud.js.map